//library
import React, { useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableRow,
	Box,
	Dialog,
	Typography,
	MenuItem,
	Select,
} from "@mui/material";

//code
import { API } from "../../services";
import useStyles from "../../components/StatusViewerTable/styles/styles";
import { TraxxButton, TraxxInput } from "../../components";

const ManualOverrideDialog = ({
	enqueueSnackbar,
	loadApplications,
	openManualOverride,
	sendManualOverrideClose,
	applicationId,
}) => {
	const classes = useStyles();

	const [inputs, setInputs] = useState({
		status: "",
		reason: "",
	});

	const handleChange = (type) => {
		return ({ target }) => setInputs({ ...inputs, [type]: target.value });
	};

	const submitManualOverride = async () => {
		if (!inputs.status || !inputs.reason) {
			enqueueSnackbar("Please enter status/reason", {
				variant: "error",
				autoHideDuration: 3000,
			});
		} else {
			await API.Application.update_application_current_status({
				status: inputs.status,
				remarks: inputs.reason,
				application_id: applicationId,
			});
			enqueueSnackbar("Application Current Status Updated Successfully", {
				variant: "success",
				autoHideDuration: 3000,
			});
			setInputs({ status: "", remark: "" });
			loadApplications();
			sendManualOverrideClose();
		}
	};

	return (
		<Dialog
			maxWidth={"md"}
			open={openManualOverride}
			onClose={sendManualOverrideClose}
		>
			<Box className={classes.manualOverrideBox}>
				<Typography variant="h6" className={classes.dialogHeader}>
					Manual Override Status
				</Typography>
				<hr />
				<Table>
					<TableBody>
						<TableRow>
							<TableCell>New Application Status</TableCell>
							<TableCell>
								<Select
									className={classes.updateManualOverrideRow}
									onChange={handleChange("status")}
									value={inputs.status}
								>
									<MenuItem value="completed">Completed</MenuItem>
									<MenuItem value="declined">Declined</MenuItem>
								</Select>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.boldText}>
								Reason for update
							</TableCell>
							<TableCell>
								<TraxxInput
									id="reason"
									className={classes.updateManualOverrideRow}
									placeholder={"No response, High risk, etc."}
									value={inputs.reason}
									onChange={handleChange("reason")}
								/>
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
				<hr />
				<TraxxButton
					className={classes.updateButton}
					onSubmit={submitManualOverride}
				>
					Update
				</TraxxButton>
			</Box>
		</Dialog>
	);
};
export default ManualOverrideDialog;
